import React from "react";

export default function TitleInput({ title, setTitle }) {
  return (
    <div className="input-container">
      <label htmlFor="title" className="input-label">
        Rug Title
      </label>
      <input
        type="text"
        id="title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />
    </div>
  );
}
